import { useContext } from 'react'
import QuotesContext from '../context/QuotesPopupProvider';


const useQuotes = () => {
    return useContext(QuotesContext);
}

export default useQuotes